import React, { useEffect, useRef } from "react";

// Scroll progress bar + cursor-following glow + drifting background orbs.
function Effects() {
  const bar = useRef(null);
  const glow = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      if (bar.current) bar.current.style.transform = `scaleX(${h > 0 ? window.scrollY / h : 0})`;
    };
    const onMove = (e) => {
      if (glow.current) glow.current.style.transform = `translate(${e.clientX - 200}px, ${e.clientY - 200}px)`;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("pointermove", onMove, { passive: true });
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("pointermove", onMove);
    };
  }, []);

  return (
    <>
      <div className="progress" ref={bar} />
      <div className="cursor-glow" ref={glow} />
      <div className="orbs" aria-hidden="true">
        <i className="orb o1" /><i className="orb o2" /><i className="orb o3" />
      </div>
    </>
  );
}

export default Effects;
